/** Canonical workout product routes — import everywhere instead of string literals. */
export const WORKOUT_ROUTES = {
  PLAN_EDITOR: '/fitness',
  TEMPLATES_LIST: '/fitness/list',
  TEMPLATES_NEW: '/fitness/create',
  TEMPLATES_DETAIL: '/fitness/update/:id',
  WORKOUT_REFERENCE_DATA: '/fitness/reference-data',
  EXERCISES_LIST: '/fitness/exercises',
  EXERCISES_NEW: '/fitness/exercises/new',
  EXERCISES_DETAIL: '/fitness/exercises/:id',
};

/** Route table for workout product pages (paths only — wired in routes.jsx). */
export const WORKOUT_ROUTE_CONFIG = [
  { path: WORKOUT_ROUTES.PLAN_EDITOR, isPrivate: false },
  { path: WORKOUT_ROUTES.TEMPLATES_LIST, isPrivate: false },
  { path: WORKOUT_ROUTES.TEMPLATES_NEW, isPrivate: false },
  { path: WORKOUT_ROUTES.TEMPLATES_DETAIL, isPrivate: false },
  { path: WORKOUT_ROUTES.WORKOUT_REFERENCE_DATA, isPrivate: true },
  { path: WORKOUT_ROUTES.EXERCISES_LIST, isPrivate: false },
  { path: WORKOUT_ROUTES.EXERCISES_NEW, isPrivate: true },
  { path: WORKOUT_ROUTES.EXERCISES_DETAIL, isPrivate: true },
];

export function templateDetailPath(id) {
  return `/fitness/update/${id}`;
}

export function exerciseDetailPath(id) {
  return `/fitness/exercises/${id}`;
}
